import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_COZY } from '@/styles';

const textColor = token('color.text.inverse');

export const tooltipContentStyles = css`
  a {
    color: ${textColor};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  h5,
  h6 {
    opacity: 0.7;
    color: ${textColor};
  }
  ul {
    padding-left: ${SPACE_COZY}px;
  }
`;
